export default __webpack_public_path__ + "static/font-ef6e10e4b455a0dd6ba8abca13c9f447.woff2";